exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".aAOUrceWy2gvw1VJ9nVpx{white-space:nowrap;color:var(--redDark);font-weight:400}html[dir=ltr] ._3CKg3eii2ICDVpVyYyZe9k{margin-right:10px}html[dir=rtl] ._3CKg3eii2ICDVpVyYyZe9k{margin-left:10px}", ""]);
// Exports
exports.locals = {
	"couponRow": "aAOUrceWy2gvw1VJ9nVpx",
	"icon": "_3CKg3eii2ICDVpVyYyZe9k"
};